module.exports = __webpack_public_path__ + "SurabhiBishnoi-e8ffa643.webp";